export const fileTypeMap: Record<string, string> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpeg',
  'image/jpg': 'jpg',
  'video/mp4': 'mp4',
  'application/zip': 'zip',
  'application/vnd.rar': 'rar',
  'application/msword': 'word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'word',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'ppt',
};

export const getFileType = (fileType: string) => {
  const typeArr = fileType.split(',');
  const typeArrSimple: string[] = typeArr
    .map((item: string) => fileTypeMap[item])
    .filter((type): type is string => type !== undefined);
  return Array.from(new Set(typeArrSimple)).join(',');
};

export const getFileTypeZh = (fileType: string) => {
  if (fileType.startsWith('image')) {
    return '图片';
  }
  if (fileType.startsWith('video')) {
    return '视频';
  }
  return '文件';
};

// 文件类型到图标的映射
const fileTypeIconMap: Record<string, string> = {
  jpg: 'pic',
  jpeg: 'pic',
  mp4: 'video',
  pdf: 'pdf',
  zip: 'zip',
  rar: 'zip',
  word: 'word',
  ppt: 'ppt',
};

export const getFileTypeIcon = (fileType: string): string => {
  // 处理单个类型
  if (fileTypeIconMap[fileType]) {
    return fileTypeIconMap[fileType];
  }

  // 处理组合类型（如 'jpg,jpeg' 或 'zip,rar'）
  const types = fileType.split(',').map(t => t.trim());
  for (const type of types) {
    if (fileTypeIconMap[type]) {
      return fileTypeIconMap[type];
    }
  }

  return '';
};

export const getFileLimitShow = (fileByte: number) => {
  const limit = Math.floor(fileByte / 1024 / 1024);
  return `${limit}MB`;
};

export const getTimeLimitShow = (durationSecond: number) => {
  const limit = Math.floor(durationSecond / 60);
  return durationSecond ? `${limit}分钟` : '';
};
